'use client';

import { createContext, useCallback, useContext, useState } from 'react';
import { IHousingListResponse, IHousingObjectResponse } from '@/types';
import { FiltersType } from '@/types';

type AppContextType = {
  objectList: IHousingListResponse['objects'];
  setObjectList: (list: IHousingObjectResponse[]) => void;
  filters: FiltersType | null;
  setFilters: (filters: FiltersType) => void;
  isStickyBarVisible: boolean;
  setIsStickyBarVisible: (visible: boolean) => void;
};

const defaultContext: AppContextType = {
  objectList: [],
  setObjectList: () => { },
  filters: null,
  setFilters: () => { },
  isStickyBarVisible: false,
  setIsStickyBarVisible: () => { },
};

export const AppContext = createContext<AppContextType>(defaultContext);

export const AppProvider = ({ children }: { children: React.ReactNode }) => {
  const [objectList, setObjectList] = useState<IHousingObjectResponse[]>([]);
  const [filters, setFilters] = useState<FiltersType | null>(null);
  const [isStickyBarVisible, setIsStickyBarVisibleState] = useState(false);
  const setIsStickyBarVisible = useCallback((visible: boolean) => {
    setIsStickyBarVisibleState(visible);
  }, []);

  return (
    <AppContext.Provider
      value={{
        objectList,
        setObjectList,
        filters,
        setFilters,
        isStickyBarVisible,
        setIsStickyBarVisible,
      }}
    >
      {children}
    </AppContext.Provider>
  );
};

export const useAppContext = () => useContext(AppContext);